/**
 * A list's shape while its first page loads: row-sized bars, one per column,
 * with each column's width as a Tailwind class. Revealed only for slow loads
 * (see `.loading-placeholder`), so a fast page never flashes it.
 */
export function ListSkeleton({
  columns,
  rows = 15,
}: {
  columns: string[];
  rows?: number;
}) {
  return (
    <div className="loading-placeholder space-y-5 p-4">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex animate-pulse gap-4">
          {columns.map((width, j) => (
            <div key={j} className={`h-5 rounded bg-tint ${width}`} />
          ))}
        </div>
      ))}
    </div>
  );
}
